import { z } from "zod";
import { ColumnSchema, ViewSchema, ViewType } from "./views";

export enum AgentSkillsViewColumn {
    TITLE = "title",
    DESCRIPTION = "description",
    CATEGORY = "category",
    CREATED_BY = "createdBy",
    LOAD_MODE = "loadMode",
    ACTIONS = "actions",
}

const makeColumnSchema = (id: AgentSkillsViewColumn) =>
    ColumnSchema.extend({ id: z.literal(id) });

export const AgentSkillsViewSchema = ViewSchema.extend({
    type: z.literal(ViewType.AGENT_SKILLS),
    columns: z.array(
        z.discriminatedUnion("id", [
            makeColumnSchema(AgentSkillsViewColumn.TITLE),
            makeColumnSchema(AgentSkillsViewColumn.DESCRIPTION),
            makeColumnSchema(AgentSkillsViewColumn.CATEGORY),
            makeColumnSchema(AgentSkillsViewColumn.CREATED_BY),
            makeColumnSchema(AgentSkillsViewColumn.LOAD_MODE),
            makeColumnSchema(AgentSkillsViewColumn.ACTIONS),
        ]),
    ),
});

export type AgentSkillsView = z.infer<typeof AgentSkillsViewSchema>;
